import React, { Component } from 'react'
import { Switch, Redirect } from 'react-router-dom';

import GuardianRoute from '../../shared/GuardianRoute';
import TimbradoMasivoFiles from './TimbradoMasivoFiles';
import TimbradoMasivoTickets from './TimbradoMasivoTickets';

class TimbradoMasivo extends Component {

  render() {
    return (
      <>
        <Switch>
          <Redirect from="/modulos/timbrado-masivo" to="/modulos/timbrado-masivo/archivos" exact />
          <GuardianRoute path="/modulos/timbrado-masivo/archivos"
            component={ TimbradoMasivoFiles }
            can="facturacion.masiva.listar.archivos"
          />
          <GuardianRoute path="/modulos/timbrado-masivo/tickets"
            component={ TimbradoMasivoTickets }
            can="facturacion.masiva.listar.tickets"
            exact
          />
        </Switch>
      </>
    )
  }
}

export default TimbradoMasivo;